<template>
  <div>
    <template v-if="this.card">
      <v-card elevation="10">
        <v-card-title class="headline">{{ this.cardHeader }}</v-card-title>
        <AnyChartCore :elevation="0" :chartType="ct" :heightSheet="this.heightSheet" :heightChart="this.heightChart" :dark="this.dark" :dataCollection="datacollection" :options="options" />
      </v-card>
    </template>
    <template v-else>
      <AnyChartCore :elevation="10" :chartType="ct" :heightSheet="this.heightSheet" :heightChart="this.heightChart" :dark="this.dark" :dataCollection="datacollection" :options="options" />
    </template>
  </div>
</template>

<script>
import AnyChartCore from "./AnyChartCore.vue";

import { chartColors } from "../../colors.js";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "AnyChart",
  components: { AnyChartCore },
  props: {
    heightSheet: {
      type: Number,
      required: true,
    },
    heightChart: {
      type: Number,
      required: true,
    },
    dark: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: false,
    },
    card: {
      type: Boolean,
      default: false,
      required: true,
    },
    cardHeader: {
      type: String,
      default: " ",
      required: false,
    },
    tabs: Number,
    start: String,
    stop: String,
    ct: {
      type: String,
      default: "Line",
      required: true,
    },
  },
  data: () => ({
    chartColors: chartColors,

    pointRadiusSmall: 0.1,
    pointRadiusLarge: 6,

    fetchSpeed: [5000, 10000, 20000, 20000, 30000, 5000, 1000],

    chartInterval: ["M", "H", "d", "d", "m", "M", "S"],

    limit: ["60", "24", "7", "31", "12", "1440", "60"],

    chartLabels: [],
    datacollection: null,
    time: null,

    options: {
      elements: {
        line: {
          tension: 0.3,
          borderWidth: 3,
        },
        point: {
          radius: 0,
        },
      },

      animation: {
        duration: 0,
      },
      hover: {
        mode: "nearest",
        intersect: true,
        animationDuration: 0,
      },
      responsiveAnimationDuration: 0,

      scales: {
        yAxes: [
          {
            type: "linear",
            display: true,
            position: "left",
            id: "y-axis-1",
            scaleLabel: {
              display: true,
              labelString: "Power / Energy",
            },
          },
          {
            type: "linear",
            display: true,
            position: "right",
            id: "y-axis-2",
            scaleLabel: {
              display: true,
              labelString: "Price",
            },
            gridLines: {
              drawOnChartArea: false,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: true,
            },
          },
        ],
      },

      legend: {
        display: true,
        labels: {
          fontColor: "white",
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    },

    optionsDark: {},
  }),
  created() {
    this.httpGet();
  },
  mounted() {
    this.timer = setInterval(() => {
      this.httpGet();
    }, this.fetchSpeed[this.tabs]);
  },
  methods: {
    toDateTime(len, input) {
      var t = new Date(input);
      var dateText = "";

      switch (this.tabs) {
        case 0:
          if (len > 1440) {
            dateText =
              t.toLocaleString(this.$i18n.locale, {
                day: "numeric",
                month: "numeric",
              }) +
              " " +
              t.toTimeString().substr(0, 5);
          } else {
            dateText = t.toTimeString().substr(0, 5);
          }

          break;
        case 1:
          dateText = t.toTimeString().substr(0, 5);
          break;
        case 2:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          break;
        case 3:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          break;
        case 4:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
          });
          break;
        case 5:
          if (len > 1440) {
            dateText =
              t.toLocaleString(this.$i18n.locale, {
                day: "numeric",
                month: "numeric",
              }) +
              " " +
              t.toTimeString().substr(0, 5);
          } else {
            dateText = t.toTimeString().substr(0, 5);
          }

          break;
        case 6:
          dateText = t.toTimeString().substr(0, 8);
          break;
      }
      return dateText;
    },
    processData(data) {
      var i;
      this.chartLabels = [];

      for (i = 0; i < data.labels.length; i++) {
        this.$set(this.chartLabels, i, this.toDateTime(data.labels.length, data.labels[i]));
      }

      if (this.$vuetify.theme.dark) {
        this.options.legend.labels = {
          fontColor: "white",
        };
      } else {
        this.options.legend.labels = {
          fontColor: "grey",
        };
      }

      let spot = [];
      let average = 0;
      let counter = 0;

      if (!("spot" in data)) {
        for (let index = 0; index < data.labels.length; index++) {
          spot.push(0);
          average = 0;
        }
      } else {
        for (let index = 0; index < data.labels.length; index++) {
          spot.push(data.spot[index]);

          if (!isNaN(data.spot[index])) {
            average += parseFloat(data.spot[index]);
            counter++;
          }

          if (index == data.labels.length - 1) {
            average /= counter;
          }
        }
      }

      let spotMax = [];
      let spotMin = [];
      let spotAVG = [];

      if ("spot" in data) {
        const max = Math.max(...data.spot);

        if (!("spotMax" in data)) {
          for (let index = 0; index < data.labels.length; index++) {
            spotMax.push(max);
          }
        } else {
          for (let index = 0; index < data.labels.length; index++) {
            if (data.spotMax.length !== 0) {
              spotMax.push(data.spotMax[index]);
            } else {
              spotMax.push(max);
            }
          }
        }

        const min = Math.min(...data.spot);

        if (!("spotMin" in data)) {
          for (let index = 0; index < data.labels.length; index++) {
            spotMin.push(min);
          }
        } else {
          for (let index = 0; index < data.labels.length; index++) {
            if (data.spotMin.length !== 0) {
              spotMin.push(data.spotMin[index]);
            } else {
              spotMin.push(min);
            }
          }
        }

        for (let index = 0; index < data.labels.length; index++) {
          spotAVG.push(Math.round(average * 100) / 100);
        }
      }

      if (this.ct == "Line") {
        this.options.scales.yAxes[0].ticks = {
          callback: function (label) {
            return label.toFixed(1) + " kW";
          },
          beginAtZero: true,
        };

        this.options.scales.yAxes[1].ticks = {
          callback: function (label) {
            return label.toFixed(0) + " Kč/kWh";
          },
          stepSize: 1,
          beginAtZero: false,

          suggestedMin: 0,
          suggestedMax: 5,
        };

        this.datacollection = {
          labels: this.chartLabels,
          datasets: [
            {
              label: this.$i18n.t("escb.chart.y1"),

              backgroundColor: this.chartColors.line.y1.backgroundColor,
              borderColor: this.chartColors.line.y1.borderColor,

              fill: true,
              borderWidth: 3,

              barPercentage: 0.5,
              barThickness: 8,
              maxBarThickness: 8,
              minBarLength: 2,

              yAxisID: "y-axis-1",

              data: this.cutValuesWithCurrentTime(data.labels, data.gridImp),

              order: 1,
            },
            {
              label: this.$i18n.t("escb.chart.y2"),

              backgroundColor: this.chartColors.line.y2.backgroundColor,
              borderColor: this.chartColors.line.y2.borderColor,

              fill: true,
              borderWidth: 3,

              barPercentage: 0.5,
              barThickness: 8,
              maxBarThickness: 8,
              minBarLength: 2,

              yAxisID: "y-axis-1",

              data: this.cutValuesWithCurrentTime(data.labels, data.gridDst),

              order: 2,
            },
            {
              label: this.$i18n.t("escb.chart.y3"),

              backgroundColor: this.chartColors.bar.y3.backgroundColor,
              borderColor: this.chartColors.bar.y3.borderColor,

              fill: true,
              borderWidth: 3,

              barPercentage: 0.5,
              barThickness: 8,
              maxBarThickness: 8,
              minBarLength: 2,

              yAxisID: "y-axis-1",

              data: this.cutValuesWithCurrentTime(data.labels, data.gridSup),

              order: 3,
            },
            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotAvg"),

              backgroundColor: this.chartColors.bar.spotAvg.backgroundColor,
              borderColor: this.chartColors.bar.spotAvg.borderColor,

              fill: true,
              borderWidth: 1.5,

              borderDash: [5, 5],

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotAVG),

              order: 4,
            },
            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotMin"),

              backgroundColor: this.chartColors.line.spotMin.backgroundColor,
              borderColor: this.chartColors.line.spotMin.borderColor,

              borderDash: [5, 5],

              fill: true,
              borderWidth: 1.5,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotMin),

              order: 5,
            },
            {
              label: this.$i18n.t("escb.chart.ySpot"),

              backgroundColor: "rgba(0, 0, 0, 0.0)",
              borderColor: this.chartColors.bar.spot.borderColor,

              fill: true,
              borderWidth: 3.5,

              borderDash: [5, 5],

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spot),

              order: 6,
            },
            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotMax"),

              backgroundColor: this.chartColors.line.spotMax.backgroundColor,
              borderColor: this.chartColors.line.spotMax.borderColor,

              borderDash: [5, 5],

              fill: true,
              borderWidth: 1.5,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotMax),

              order: 7,
            },
          ],
        };
      }

      if (this.ct == "Bar") {
        this.options.scales.yAxes[0].ticks = {
          callback: function (label) {
            return label.toFixed(1) + " kWh";
          },

          beginAtZero: true,
        };

        this.options.scales.yAxes[1].ticks = {
          callback: function (label) {
            return label.toFixed(0) + " Kč/kWh";
          },
          stepSize: 1,
          beginAtZero: false,

          suggestedMin: 0,
          suggestedMax: 5,
        };

        this.datacollection = {
          labels: this.chartLabels,
          datasets: [
            {
              type: "bar",
              label: this.$i18n.t("escb.chart.y1"),

              backgroundColor: this.chartColors.bar.y1.backgroundColor,
              borderColor: this.chartColors.bar.y1.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-1",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, data.gridImp),

              order: 1,
            },
            {
              type: "bar",
              label: this.$i18n.t("escb.chart.y2"),

              backgroundColor: this.chartColors.bar.y2.backgroundColor,
              borderColor: this.chartColors.bar.y2.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-1",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, data.gridDst),

              order: 2,
            },
            {
              type: "bar",
              label: this.$i18n.t("escb.chart.y3"),

              backgroundColor: this.chartColors.bar.y3.backgroundColor,
              borderColor: this.chartColors.bar.y3.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-1",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, data.gridSup),

              order: 3,
            },

            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotAvg"),

              backgroundColor: this.chartColors.bar.spotAvg.backgroundColor,
              borderColor: this.chartColors.bar.spotAvg.borderColor,

              borderDash: [5, 5],

              fill: true,
              borderWidth: 1.5,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotAVG),

              order: 4,
            },

            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotMin"),

              backgroundColor: this.chartColors.bar.spotMin.backgroundColor,
              borderColor: this.chartColors.bar.spotMin.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotMin),

              pointStyle: "rectRounded",

              borderDash: [5, 5],

              showLine: false,
              pointRadius: this.pointRadiusLarge,
              pointHoverRadius: this.pointRadiusLarge,
              hoverBorderWidth: this.pointRadiusLarge,

              pointBackgroundColor: this.chartColors.bar.spot.backgroundColor,

              order: 5,
            },
            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpot"),

              backgroundColor: this.chartColors.bar.spot.backgroundColor,
              borderColor: this.chartColors.bar.spot.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spot),

              pointStyle: "rectRounded",

              showLine: false,
              pointRadius: this.pointRadiusLarge,
              pointHoverRadius: this.pointRadiusLarge,
              hoverBorderWidth: this.pointRadiusLarge,
              pointBackgroundColor: this.chartColors.bar.spot.backgroundColor,

              order: 6,
            },
            {
              type: "line",
              label: this.$i18n.t("escb.chart.ySpotMax"),

              backgroundColor: this.chartColors.bar.spotMax.backgroundColor,
              borderColor: this.chartColors.bar.spotMax.borderColor,

              fill: true,
              borderWidth: 3,

              yAxisID: "y-axis-2",

              data: this.fillEmptyArrayWithZeroes(data.labels.length, spotMax),

              pointStyle: "rectRounded",

              borderDash: [5, 5],

              /* spotMin a spotMax line! */

              /* chartInterval: ["M", "H", "d", "d", "m", "M", "S"], */

              showLine: false,
              pointRadius: this.pointRadiusLarge,
              pointHoverRadius: this.pointRadiusLarge,
              hoverBorderWidth: this.pointRadiusLarge,

              pointBackgroundColor: this.chartColors.bar.spot.backgroundColor,

              order: 7,
            },
          ],
        };
      }

      if (this.ct == "Line") {
        if (this.chartInterval[this.tabs] === "M") {
          if (!("spot" in data)) {
            // Když server nevrací SPOT, tak to uživatelům nezobrazovat (ani jako legenda v datasetu)
            // U POWER jsou to poslední 4
            this.datacollection.datasets.pop();
            this.datacollection.datasets.pop();
            this.datacollection.datasets.pop();
            this.datacollection.datasets.pop();
          }
        }
      } else if (this.ct == "Bar") {
        if (this.chartInterval[this.tabs] === "H") {
          delete this.datacollection.datasets[4].showLine;
          delete this.datacollection.datasets[4].pointRadius;
          delete this.datacollection.datasets[4].pointHoverRadius;
          delete this.datacollection.datasets[4].hoverBorderWidth;

          this.datacollection.datasets[4].borderWidth = 1.0;

          delete this.datacollection.datasets[6].showLine;
          delete this.datacollection.datasets[6].pointRadius;
          delete this.datacollection.datasets[6].pointHoverRadius;
          delete this.datacollection.datasets[6].hoverBorderWidth;

          this.datacollection.datasets[6].borderWidth = 1.0;
        } else if (this.chartInterval[this.tabs] === "d" || this.chartInterval[this.tabs] === "m") {
          delete this.datacollection.datasets[4].borderDash;
          delete this.datacollection.datasets[6].borderDash;
        }
      }
    },
    httpGet() {
      if (this.card === true) {
        this.limit[0] = "60";
      } else {
        this.limit[0] = "1440";
      }

      let parameters = "?time=" + this.chartInterval[this.tabs] + "&type=" + (this.ct == "Line" ? "P" : "E");

      if (this.limit[this.tabs] != "1440") {
        parameters += "&limit=" + this.limit[this.tabs];
      }

      if (this.start !== "" && this.stop !== "") {
        parameters += "&dt1=" + this.start + "&dt2=" + this.stop;
      }

      ServiceClient.dataCore(ServiceClient.getAPIUrl("escbchart"), null, parameters, "GET")
        .then((data) => {
          this.processData(data);
        })
        .catch((error) => {
          this.datacollection = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    cutValuesWithCurrentTime(labels, data) {
      let array = [];
      let date = new Date();

      date.setMinutes(date.getMinutes() - 1);

      for (let index = 0; index < labels.length; index++) {
        let labelDate = new Date(labels[index]);
        if (labelDate < date) {
          array.push(data[index]);
        } else {
          array.push(null);
        }
      }

      return array;
    },
    fillEmptyArrayWithZeroes(x, y) {
      var Arr = y;
      var Diff = x - y.length;

      if (Diff === 0) {
        return Arr;
      }

      Arr.reverse();
      for (let i = 0; i < Diff; i++) {
        Arr.push(0);
      }
      Arr.reverse();

      return Arr;
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
  watch: {
    tabs: function () {
      this.datacollection = null;

      clearInterval(this.timer);

      this.timer = setInterval(() => {
        this.httpGet();
      }, this.fetchSpeed[this.tabs]);

      this.httpGet();
    },
    start: function () {
      this.datacollection = null;
      this.httpGet();
    },
    ct: function () {
      this.datacollection = null;
      this.httpGet();
    },
    dark: function () {
      if (this.dark === true) {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#FFFFFF",
          },
        };
      } else {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#000000",
          },
        };
      }
    },
  },
};
</script>
